import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ConnectivityService } from './connectivity.service';

@Injectable()
export class ConnectivityInterceptor implements HttpInterceptor {
    constructor(private connectivity: ConnectivityService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this.connectivity.isMonitoredRequest(req.url) || this.connectivity.isHealthRequest(req.url)) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        this.connectivity.reportTransportSuccess();
                    }
                },
                error: (error: unknown) => {
                    if (error instanceof HttpErrorResponse && error.status === 0) {
                        this.connectivity.reportTransportFailure();
                    }
                },
            })
        );
    }
}
